import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppStoreBanner } from '@ampcore/design-system'

export class AppStoreBannerElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'app-store-banner-element'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)
    const variant = this.getAttribute('data-variant')
    const isAndroidEnabled = this.getAttribute('data-is-android-enabled')
    const isIosAllDevicesEnabled = this.getAttribute(
      'data-is-ios-all-devices-enabled'
    )
    const root = ReactDOM.createRoot(reactContainer)
    root.render(
      <AppStoreBanner
        variant={variant as never}
        isAndroidEnabled={isAndroidEnabled === 'true'}
        isIosAllDevicesEnabled={isIosAllDevicesEnabled === 'true'}
      />
    )
  }
}
